import { useGetUserInformationQuery } from 'services/api/user.api';

const useIsAdmin = () => {
  const { data } = useGetUserInformationQuery(null);
  return data?.isAdmin || false;
};

export default useIsAdmin;
